import { Progress } from "@ecco/ui/progress";
import { Button } from "@ecco/ui/button";
import { Flex } from "@ecco/ui/flex";
import type { FC, ReactNode } from "react";
import { headerStyle, headerInlineResultsStyle, progressBarStyle } from "./styles";
import { Box } from "@ecco/ui/box";

export interface PaginationResultsHeaderProps {
    children: ReactNode;
}

export interface PaginationResultsProgressProps {
    currentResultsCount: number;
    totalResultsCount: number;
}

export interface PaginationResultsInlineHeaderProps {
    children: ReactNode;
}

export interface PaginationResultsButtonProps {
    children: ReactNode;
    onShowMore: () => void;
    isLoading?: boolean;
}

export interface PaginationResultsProps {
    children: ReactNode;
}

export const PAGINATION_RESULTS_HEADER_TEST_ID = "pagination-results-header";
export const PAGINATION_RESULTS_BUTTON_TEST_ID = "pagination-results-button";
export const PAGINATION_RESULTS_PROGRESS_TEST_ID = "pagination-results-progress";

export const PaginationResultsHeader: FC<PaginationResultsHeaderProps> = ({ children }) => (
    <Box sx={headerStyle}>{children}</Box>
);

export const PaginationResultsInlineHeader: FC<PaginationResultsInlineHeaderProps> = ({
    children,
}) => <Box sx={headerInlineResultsStyle}>{children}</Box>;

export const PaginationResultsProgress: FC<PaginationResultsProgressProps> = ({
    currentResultsCount,
    totalResultsCount,
}) => {
    const value = (currentResultsCount / totalResultsCount) * 100;

    return (
        <Progress
            sx={progressBarStyle}
            value={value}
            data-testid={PAGINATION_RESULTS_PROGRESS_TEST_ID}
        />
    );
};

export const PaginationResultsButton: FC<PaginationResultsButtonProps> = ({
    children,
    onShowMore,
    isLoading,
}) => (
    <Button
        onClick={onShowMore}
        isLoading={isLoading}
        variant="solid"
        colorScheme="black"
        data-testid={PAGINATION_RESULTS_BUTTON_TEST_ID}
    >
        <span>{children}</span>
    </Button>
);

export const PaginationResults: FC<PaginationResultsProps> = ({ children }) => {
    return (
        <Flex
            gap={4}
            flexDirection="column"
            justifyContent={"flex-start"}
            alignItems={"center"}
            mb={[16, 16, 24]}
            w={"100%"}
        >
            {children}
        </Flex>
    );
};
